import React from "react";

interface Iprops {
  handleChange: () => {};
  fname: string;
  lname: string;
  email: string;
  styles: { banner: { registerBlock: { input: any; suggestion: any } } };
  handleSubmit: () => {};
}

const RegisterForn = ({
  handleChange,
  fname,
  lname,
  email,
  styles,
  handleSubmit,
}: Iprops) => {
  return (
    <form name="register">
      <input
        style={styles.banner.registerBlock.input}
        type="text"
        name="fname"
        placeholder="First Name"
        value={fname}
        onChange={handleChange}
        required
      />
      <div className="alert alert-danger hide" role="alert">
        This field is required.
      </div>

      <input
        style={styles.banner.registerBlock.input}
        type="text"
        name="lname"
        placeholder="Last Name"
        value={lname}
        onChange={handleChange}
        required
      />
      <div className="alert alert-danger hide" role="alert">
        This field is required.
      </div>

      <input
        style={styles.banner.registerBlock.input}
        type="text"
        name="email"
        placeholder="Email"
        value={email}
        onChange={handleChange}
        required
      />
      <div className="alert alert-danger hide" role="alert">
        This field is required.
      </div>

      <input
        style={styles.banner.registerBlock.input}
        type="password"
        name="password"
        placeholder="New Password"
        onChange={handleChange}
        required
      />
      <div className="alert alert-danger hide" role="alert">
        This field is required.
      </div>

      <input
        style={styles.banner.registerBlock.input}
        type="password"
        name="passwordConfirmation"
        placeholder="Confirm Password"
        onChange={handleChange}
        required
      />
      <div className="alert alert-danger hide" role="alert">
        This field is required.
      </div>

      <span style={styles.banner.registerBlock.suggestion}>
        8 character minimum with at least 1 number and 1 letter.
      </span>

      <button
        style={styles.banner.registerBlock.input}
        type="button"
        onClick={handleSubmit}
        className="btn_start"
      >
        Start Searching
      </button>
    </form>
  );
};

export default RegisterForn;
